import React from 'react';
import Dropzone from 'react-dropzone'

const styles = {
  default: {
    width: '100%',
    maxWidth: '700px',
    height: '124px',
    padding: '12px',
    border: '2px dashed #666',
    borderRadius: '5px',
    boxSizing: 'border-box',
  },
  active: {
    borderColor: '#2196f3',
  },
  disabled: {
    opacity: 0.5,
  },
}

export default function({onDrop}) {
  return (
    <Dropzone
      onDrop={onDrop}
      accept=".mp3,.mp4"
      style={styles.default}
      activeStyle={styles.active}
      disabledStyle={styles.disabled}
    >
      <p>Try dropping files here, or click to select files to upload.</p>
      <p>Only *.mp3 and *.mp4 files will be accepted</p>
    </Dropzone>
  )
}



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/FileUploader/Dropzone.js